import { InterviewStatus } from "components/CandidateView";
import {PositionProps, SkillsProps} from "../../utils/types";

export enum JobBoardDetailTab {
    newOrViewed = "newOrViewed",
    shortlisted = "shortlisted",
    hideCandidates = "hideCandidates",
}

export enum ApplicationStatus {
    posted = 0,
    viewed = 1,
    opened = 2,
    revealed = 3,
    removed = 4,
    shortlisted = 5,
    declined = 6
}

export type Application = {
    applicationId: number,
    hygienistId: number,
    hireResumeUrl: string,
    name: string,
    type: number,
    graduation: string
    yearsOfExperience: string
    rating: number
    status: ApplicationStatus,
    interviewStatus: InterviewStatus,
    distance: string,
    school: string,
    resumeViewed: number,
    graduationYear: number,
    showContacts: boolean
    hygienistStatus: number
    about?: string | null,
    skills?: SkillsProps[];
    photoUrl?: string
    workExperience?: PositionProps[];
};
